import { RouteProp, useNavigation, useRoute } from '@react-navigation/native';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { MainLayout } from '@shared/components/md-design-system/Layout/MainLayout';
import { TNavigationStack, TNavigationStackWithParams } from 'app/types';
import { usePost } from 'app/queryProvider';
import { useAuth } from 'app/auth/hooks/useAuth';
import { DrugIntakeSubmitForm, IDrugIntakeSubmitForm } from '../components/forms';
import { Loading } from '@shared/components/loading';
import { IDrugIntakeRequest } from '../types';

const DrugIntakeSubmitFormScreen = () => {
  const route = useRoute<RouteProp<TNavigationStackWithParams<{ activityId: string }>, 'DrugIntakeSubmit'>>();
  const { activityId } = route.params;
  const { meData } = useAuth();

  const navigation = useNavigation<NativeStackNavigationProp<TNavigationStack>>();

  const {mutate: createDrugIntake, isPending: isCreatingDrugIntake} = usePost<IDrugIntakeRequest, undefined>({
    options: {
      onSuccess: () => {
        navigation.navigate("ActivitySuccess", {administered: false});
      },
    },
  });

  const handleGoToHome = () => {
    navigation.navigate("Homepage");
  };

  const handleSubmit = (data: IDrugIntakeSubmitForm) => {
    createDrugIntake({
      resource: { name: "pathways", id: meData?.current_pathway.id },
      url: `/activities/${activityId}/drug-intake`,
      data: {
        administered: false,
        ...(data.selectedOption.text && { reason: data.selectedOption.text }),
        ...(data.notes && { notes: data.notes })
      },
    });
  };

  if (isCreatingDrugIntake) {
    return <Loading />
  }

  return (
    <MainLayout navigation={handleGoToHome} scrollable={true}>
      <DrugIntakeSubmitForm handleSubmit={handleSubmit} />
    </MainLayout>
  );
};

export default DrugIntakeSubmitFormScreen;